import { PageTitle } from "@/components/Common";
import { PanelRegistroQR } from "@/components/PanelRegistroQR";

export default function CoordRegistroDocentes() {
  return (
    <div data-testid="coord-registro-docentes">
      <PageTitle title="Registro de docentes por QR"
                 subtitle="Comparta o imprima el código QR. Cada solicitud queda pendiente de su revisión." />
      <PanelRegistroQR rol="docente" />
    </div>
  );
}
